import { clsx } from "clsx"

import type { InferReturn, PropsWithClassName } from "~/@types/generics"
import type { getCollectionNavigation } from "~/data/collection/navigation/get"
import InlineCta from "~/components/ui/InlineCta"
import { EmblaSlider } from "~/components/shared/EmblaSlider/index.client"

import * as css from "./styles.css"

export function CollectionNavigation({
  className,
  collectionNavigationLinks,
}: PropsWithClassName<{ collectionNavigationLinks: InferReturn<typeof getCollectionNavigation> }>) {
  if (!collectionNavigationLinks?.length) {
    return null
  }

  return (
    <div className={clsx(className, css.CollectionNavigation)}>
      <EmblaSlider className={clsx(css.slider)} hideOverflow withBlurredPrev>
        {collectionNavigationLinks.map((cta, index) => (
          <InlineCta key={index} className={clsx(css.inlineCta)} {...cta} color="black" size="small" withLine />
        ))}
      </EmblaSlider>
    </div>
  )
}
